import ValuePropositionFeatures from './ValuePropositionFeatures';

export default ValuePropositionFeatures;
